'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

exports.default = (0, _immutable.Record)({
  client: null,
  clientTs: null,
  clientType: null,
  descriptor: null,
  id: null,
  messageDeletedStatus: null,
  metadata: null,
  senderId: null,
  senderType: null,
  threadId: null,
  timestamp: null
}, 'PubNubMessageRecord');
module.exports = exports['default'];